import React from "react";

const FotoBiblio = ({ foto, alt, tamanio }) => {
    // let url = `http://biblioteca.esen.edu.sv/${foto}`;
    // let url = `https://201.247.105.75:3000/static/usrs/${foto}`;
    return(
        <div className="text-center mb-3 mb-sm-0">
        {/* <img className = { tamanio } src = { url }  alt = { alt } /> */}
        <span className="display-4 text-muted" role="img" aria-label={alt}>
            <i className="fa fa-book" aria-hidden="true"></i>
        </span>
        </div>
    )
}

export default FotoBiblio
